import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useFirestore } from "reactfire";
import WorkshopView from "../../../components/workshop-view/WorkshopView";
import image1 from "../../../../../shared/resources/batmanlogo.jpg";
import "./styles.scss";
import PageHeader from "../../../components/page-header/PageHeader";

interface Workshop {
  id: string;
  title: string;
  description: string;
  createdAt: Date;
  orderNo: number;
  thumbnail: string;
}
const PublicWorkshopsView = () => {
  const [workshops, setWorkshops] = useState<Workshop[]>([]);
  const store = useFirestore();
  const [mainLoading, setMainLoading] = useState(true);
  const [fWorkshops, setFWorkshops] = useState<Workshop[]>([]);

  useEffect(() => {
    setFWorkshops((ps) => {
      return workshops.sort(
        (a: Workshop, b: Workshop) => a.orderNo - b.orderNo
      );
    });
  }, [workshops]);
  useEffect(() => {
    return store
      .collection("publicWorkshops")
      .where("active", "==", true)
      .onSnapshot({}, (snapshot) => {
        console.log("ok this");
        setMainLoading(false);
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            setWorkshops((ps) => {
              ps.push({
                id: change.doc.id,
                title: change.doc.data().title,
                description: change.doc.data().description,
                createdAt: change.doc.data().createdAt,
                orderNo: change.doc.data().orderNo,
                thumbnail: change.doc.data().thumbnail,
              });
              return Object.assign([], ps);
            });
          }
          if (change.type === "modified") {
            setWorkshops((ps) => {
              const modified = ps.map((a) => {
                if (a.id === change.doc.id) {
                  return {
                    id: change.doc.id,
                    title: change.doc.data().title,
                    description: change.doc.data().description,
                    createdAt: change.doc.data().createdAt,
                    country: change.doc.data().country,
                    orderNo: change.doc.data().orderNo,
                    thumbnail: change.doc.data().thumbnail,
                  };
                } else {
                  return a;
                }
              });
              return Object.assign([], modified);
            });
          }
          if (change.type === "removed") {
            setWorkshops((ps) => {
              const removed = ps.filter((a) => a.id !== change.doc.id);
              return Object.assign([], removed);
            });
          }
        });
      });
  }, [store]);

  return (
    <>
      <PageHeader title="Public Workshops" />
      <Container
        fluid
        style={{
          paddingTop: "200px",
          paddingLeft: "50px",
          paddingRight: "50px",
        }}
      >
        <Row>
          {workshops.length === 0 && !mainLoading && (
            <Col
              className="text-center"
              style={{
                marginTop: "100px",
                color: "grey",
              }}
            >
              <h4>There are no workshops created for the public library yet.</h4>
            </Col>
          )}
          <Col xs={12}></Col>
          {fWorkshops.map((wk, index) => {
            return (
              <Col
                xs={12}
                sm={12}
                md={6}
                lg={4}
                className="py-2 pl-0 pr-0"
                key={index}
              >
                <WorkshopView
                  index={index}
                  id={wk.id}
                  title={wk.title}
                  description={wk.description}
                  imageURL={image1}
                  orderNo={wk.orderNo}
                  thumbnail={wk.thumbnail}
                />
              </Col>
            );
          })}
        </Row>
      </Container>
    </>
  );
};

export default PublicWorkshopsView;
